import React from "react"
import { FaCode, FaSketch, FaRegHandshake } from "react-icons/fa"
export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web開発",
    text: `ウェブサイト制作・アプリ開発・オンラインサービス開発、デジタルコンテンツ制作、マーケティング＆ブランディング、営業`,
  },
  {
    id: 2,
    icon: <FaSketch className="service-icon" />,
    title: "DX支援",
    text: `パソコン操作研修、クラウド運用、デジタル化＆自動化支援、リモートワーク環境（ワークスペース）構築、マニュアル制作`,
  },
  {
    id: 3,
    icon: <FaRegHandshake className="service-icon" />,
    title: "プログラミング講座",
    text: `初心者大歓迎。DjangoやWordPressを使ったWebサイト・アプリ開発のノウハウを基礎から丁寧に指導します`,
  },
]
